import React from "react";
import Footer from "../../components/Footer";
import Head from "../../components/Head";
import WelcomeModal from "../../components/WelcomeModal";
import { useAuth } from "../../hooks/auth";

const Private: React.FC = (props) => {  
  const { showWelcomeModal, closeWelcomeModal } = useAuth();

  return (    
    <div className="page-main" >
      <Head/>
      <div style={{ overflow:"auto"}}>{props.children}</div>
      <Footer />
      
      <WelcomeModal 
        isOpen={showWelcomeModal}
        toggle={closeWelcomeModal}
      />
    </div>
  );
};

export default Private;
